import Polyglot from 'node-polyglot';
import { snakeToHumanCase, polyglotRegistry } from '@cyberint/common-utils';
import STRINGS from './resources';
import './trans'; // side-effect: registers the i18next 'alerts' bundle on load

const polyglot = new Polyglot({
  locale: polyglotRegistry.getLocale(),
  phrases: STRINGS
});

// Exported so other libs that reuse these phrases (e.g. the alerts catalog) load the same locale chunks.
export const sharedAlertsLoaders = {
  es: () => import(/* webpackChunkName: "common-alerts-locale-es" */ './locales/es'),
  fil: () => import(/* webpackChunkName: "common-alerts-locale-fil" */ './locales/fil'),
  ja: () => import(/* webpackChunkName: "common-alerts-locale-ja" */ './locales/ja'),
  th: () => import(/* webpackChunkName: "common-alerts-locale-th" */ './locales/th')
};

polyglotRegistry.register(polyglot, {
  en: STRINGS,
  loaders: sharedAlertsLoaders
});

export const alertsT = (key, params, defaultValue) =>
  polyglot.t(key, {
    ...params,
    _: defaultValue || snakeToHumanCase(key)
  });
export const t = alertsT;
export const alertsTranslate = alertsT;

export default alertsT;
